import React, { useState, useEffect, useRef } from 'react'
import { Carousel, Stack } from 'react-bootstrap'
import { Image } from '@ztechapps/webui.util'

const images = [
  '/images/header-specialty.jpeg',
  '/images/header-gov-military.jpeg',
  '/images/header-aerospace.jpeg',
  '/images/header-research-other.jpeg',
]

export default function Intro() {
  const [activeIndex, setActiveIndex] = useState(0)
  const [carouselInterval, setCarouselInterval] = useState<number | null | undefined>(undefined)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (activeIndex === 4) {
      setCarouselInterval(null)
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        setCarouselInterval(undefined)
      }, 27000)
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
      setCarouselInterval(undefined)
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [activeIndex])

  const handleSelect = (selectedIndex: number) => {
    setActiveIndex(selectedIndex)
  }

  return (
    <section className="section-intro  ">
      <div className="intro-banner-wrap">
        <Carousel activeIndex={activeIndex} onSelect={handleSelect} interval={carouselInterval}>
          {images.map((url) => (
            <Carousel.Item key={url}>
              <Stack>
                <Image url={url} name="Our customers" />
              </Stack>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  )
}
